
import { ListConfig } from "./tabs";
import {  useStoreState } from "../../store/easy-peasy/hooks";
import React from "react";



export const Settings = () => {
  const setting = useStoreState((store) => store.setting);
 

  const redirectPage = () => {
    switch (setting) {
      case "config":
        return <ListConfig />;
      default:
        return <ListConfig />;
    }
  };

 

  return (
    <div className="min-h-screen bg-white">
      <div className="w-full">
        <div className="bg-white w-full p-4 overflow-hidden border-b border-gray-100">
          {redirectPage()}
        </div>
      </div>
    </div>
  );
};
